// Reducer for the shortcutById, the sub-state under shortcuts.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultShortcutState = {
  ...DefaultState
}

export const shortcutById = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultShortcutState,
  actionRequest: ActionTypes.REQUEST_SHORTCUT,
  actionFailure: ActionTypes.REQUEST_SHORTCUT_FAILURE,
  actionReceive: ActionTypes.RECEIVE_SHORTCUT,
  actionInvalidate: ActionTypes.INVALIDATE_SHORTCUT
})
